import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useCloseTab } from '../../components/tabs/TabsContext';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import { VALIDATION_MESSAGE } from '../../utils/constants';
import Spinner from '../../components/Spinner';
import Input from '../../components/Input';
import Button from '../../components/Button';
import { onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import { WEIGHT_PATH, getWeightById, updateWeight } from '../../api/weightApi';

const WeightEditPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams();
    const closeTab = useCloseTab()
    const dispatch = useDispatch()
    const [weight, setWeight] = useState({

    })
    const [errors, setErrors] = useState({})
    const pendingApiCall = useApiProgress('put', `${WEIGHT_PATH}`, false)
    const pendingApiCallLoading = useApiProgress('get', `${WEIGHT_PATH}`, false)

    useEffect(() => {
        getWeightById(id).then(res => setWeight(res.data))
    }, [id])

    const onClickSubmit = () => {
        updateWeight(id, weight).then(res => {
            closeTab()
            toast.success('Gramaj güncellendi')
        }).catch(err => {
            toast.error(VALIDATION_MESSAGE)
            setErrors(err.response.data.validationErrors)
        })
    }

    if (pendingApiCallLoading) return (
        <div className='flex justify-center'>
            <Spinner />
        </div>
    )

    return (
        <div className='grid grid-cols-1 place-items-center'>
            <div className='col-span-6 w-96'>
                <label className='text-xl mb-5 block'>Gramaj Düzenle</label>
                <Input
                    label='Gramaj Kodu'
                    name='code'
                    value={weight.code}
                    placeholder='Gramaj kodu girin'
                    error={errors.code}
                    onChange={e => onChange(e, setWeight, setErrors)}
                />
                <Input
                    label='Gramaj Adı'
                    name='name'
                    value={weight.name}
                    placeholder='Gramaj adı girin'
                    error={errors.name}
                    onChange={e => onChange(e, setWeight, setErrors)}
                />
                <Textarea
                    label='Açıklama'
                    name='description'
                    value={weight.description}
                    placeholder='Açıklama girin'
                    onChange={e => onChange(e, setWeight, setErrors)}
                />
                <div className='flex justify-center'>
                    <Button
                        text='Kaydet'
                        variant='green'
                        onClick={onClickSubmit}
                        pending={pendingApiCall}
                    />
                </div>
            </div>
        </div>
    )
}

export default WeightEditPage